(function () {
  if (customElements.get('quantity-break-tiers')) return;

  function money(cents) {
    var iso = (window.theme && theme.shopSettings && theme.shopSettings.isoCode) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: iso }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function toCents(v) {
    if (v === null || v === undefined || v === '') return 0;
    return Math.round(parseFloat(v) * 100);
  }

  class QuantityBreakTiers extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.formId = this.dataset.formId;
      this.handle = this.dataset.productHandle;
      this.defaultCollection = this.dataset.defaultCollection || '';
      this.discounts = (this.dataset.tierDiscounts || '0,10,15,20').split(',').map(Number);
      this.extraTabs = (this.dataset.tabCollections || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      this.hiddenHandles = (this.dataset.hiddenCollections || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);

      this.tier = 1;
      this.slots = { 2: [null, null], 3: [null, null, null], 4: [null, null, null, null] };
      this.activeSlot = null;
      this.cache = {};
      this.currentProduct = null;

      this.tierEls = Array.prototype.slice.call(this.querySelectorAll('.qbt__tier'));
      this.hintEl = this.querySelector('.qbt__hint');

      var self = this;
      this.tierEls.forEach(function (el) {
        el.addEventListener('click', function (e) {
          if (e.target.closest('.qbt__slot-choose') || e.target.closest('.qbt__slot')) return;
          self.selectTier(Number(el.dataset.tier));
        });
      });

      fetch('/products/' + this.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          self.currentProduct = p;
          self.renderAll();
        })
        .catch(function () {});

      this.bindNativeButtons();
      this.buildModal();
      this.renderAll();

      var form = document.getElementById(this.formId);
      if (form) {
        form.addEventListener('change', function () { setTimeout(function () { self.renderAll(); }, 50); });
      }
      if (window.subscribe && window.PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { self.renderAll(); }, 50); });
      }
    }

    /* ---------- current product ---------- */
    currentVariant() {
      var form = document.getElementById(this.formId);
      var input = form && form.querySelector('[name="id"]');
      var id = input ? Number(input.value) : null;
      var p = this.currentProduct;
      if (!p) return null;
      var v = p.variants.filter(function (x) { return x.id === id; })[0] || p.variants[0];
      return {
        productId: p.id,
        variantId: v.id,
        title: p.title + (v.title && v.title !== 'Default Title' ? ' - ' + v.title : ''),
        image: (v.featured_image && v.featured_image.src) || p.featured_image || '',
        price: v.price,
        compare: v.compare_at_price || 0
      };
    }

    slotItem(tier, idx) {
      if (idx === 0) return this.currentVariant();
      return this.slots[tier][idx];
    }

    /* ---------- tiers ---------- */
    selectTier(n) {
      this.tier = n;
      this.renderAll();
    }

    renderAll() {
      var self = this;
      this.tierEls.forEach(function (el) {
        var n = Number(el.dataset.tier);
        var selected = n === self.tier;
        el.classList.toggle('is-selected', selected);
        var radio = el.querySelector('.qbt__radio');
        if (radio) radio.checked = selected;
        if (n > 1) self.renderSlots(el, n, selected);
        self.renderPrice(el, n);
      });
      if (this.hintEl) {
        var missing = this.missingCount();
        this.hintEl.hidden = !(this.tier > 1 && missing > 0);
        this.hintEl.textContent = missing > 0 ? 'Choose ' + missing + ' more product' + (missing > 1 ? 's' : '') + ' to complete your bundle' : '';
      }
    }

    missingCount() {
      if (this.tier === 1) return 0;
      var m = 0;
      for (var i = 0; i < this.tier; i++) if (!this.slotItem(this.tier, i)) m++;
      return m;
    }

    renderPrice(el, n) {
      var cur = this.currentVariant();
      var base = cur ? cur.price : 0;
      var total = 0;
      for (var i = 0; i < n; i++) {
        var it = n === 1 ? cur : this.slotItem(n, i);
        total += it ? it.price : base;
      }
      var d = this.discounts[n - 1] || 0;
      var now = Math.round(total * (100 - d) / 100);
      var nowEl = el.querySelector('.qbt__price-now');
      var cmpEl = el.querySelector('.qbt__price-compare');
      if (!total) return;
      if (nowEl) nowEl.textContent = money(now);
      if (cmpEl) {
        cmpEl.textContent = d > 0 ? money(total) : '';
        cmpEl.hidden = !(d > 0);
      }
    }

    renderSlots(el, n, selected) {
      var wrap = el.querySelector('.qbt__slots');
      if (!wrap) return;
      wrap.hidden = !selected;
      if (!selected) return;
      wrap.textContent = '';
      var self = this;
      for (var i = 0; i < n; i++) {
        (function (i) {
          var it = self.slotItem(n, i);
          var row = document.createElement('div');
          row.className = 'qbt__slot' + (it ? ' is-filled' : '');

          var thumb = document.createElement('div');
          thumb.className = 'qbt__slot-thumb';
          if (it && it.image) {
            var img = document.createElement('img');
            img.src = it.image;
            img.alt = '';
            img.loading = 'lazy';
            thumb.appendChild(img);
          }
          row.appendChild(thumb);

          var name = document.createElement('span');
          name.className = 'qbt__slot-name';
          name.textContent = it ? it.title : 'Product ' + (i + 1);
          row.appendChild(name);

          if (i === 0) {
            var lock = document.createElement('span');
            lock.className = 'qbt__slot-locked';
            lock.textContent = 'This product';
            row.appendChild(lock);
          } else {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'qbt__slot-choose';
            btn.textContent = it ? 'Change' : 'Choose';
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              self.openModal(n, i);
            });
            row.appendChild(btn);
          }
          wrap.appendChild(row);
        })(i);
      }
    }

    /* ---------- modal ---------- */
    buildModal() {
      var m = document.createElement('div');
      m.className = 'qbt__modal';
      m.hidden = true;
      m.innerHTML =
        '<div class="qbt__modal-overlay"></div>' +
        '<div class="qbt__modal-panel" role="dialog" aria-modal="true">' +
        '<div class="qbt__modal-header"><h4>Choose a product</h4><button type="button" class="qbt__modal-close" aria-label="Close">&times;</button></div>' +
        '<div class="qbt__modal-search"><input type="search" placeholder="Search" autocomplete="off"></div>' +
        '<div class="qbt__tabs-hint">Swipe to see more categories</div>' +
        '<div class="qbt__tabs"></div>' +
        '<div class="qbt__modal-body"><div class="qbt__product-list"></div>' +
        '<div class="qbt__loading" hidden>Loading...</div>' +
        '<div class="qbt__no-results" hidden>No products found</div>' +
        '<div class="qbt__scroll-sentinel"></div></div></div>';
      document.body.appendChild(m);
      this.modal = m;
      this.listEl = m.querySelector('.qbt__product-list');
      this.tabsEl = m.querySelector('.qbt__tabs');
      this.tabsHintEl = m.querySelector('.qbt__tabs-hint');
      this.loadingEl = m.querySelector('.qbt__loading');
      this.noResEl = m.querySelector('.qbt__no-results');
      this.searchEl = m.querySelector('input');
      var self = this;
      m.querySelector('.qbt__modal-overlay').addEventListener('click', function () { self.closeModal(); });
      m.querySelector('.qbt__modal-close').addEventListener('click', function () { self.closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) self.closeModal(); });
      this.searchEl.addEventListener('input', function () { self.filterList(); });
      this.io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) self.loadMore();
      }, { root: m.querySelector('.qbt__modal-body'), rootMargin: '200px' });
      this.io.observe(m.querySelector('.qbt__scroll-sentinel'));
    }

    tabHandles() {
      var list = [];
      if (this.defaultCollection) list.push(this.defaultCollection);
      this.extraTabs.forEach(function (h) { if (list.indexOf(h) < 0) list.push(h); });
      var hidden = this.hiddenHandles;
      list = list.filter(function (h) { return hidden.indexOf(h) < 0; });
      if (!list.length) list.push('all');
      return list;
    }

    openModal(tier, idx) {
      this.activeSlot = { tier: tier, idx: idx };
      this.modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      this.searchEl.value = '';
      var self = this;
      this.tabsEl.textContent = '';
      var handles = this.tabHandles();
      if (this.tabsHintEl) this.tabsHintEl.hidden = handles.length < 3;
      handles.forEach(function (h) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'qbt__tab';
        b.dataset.handle = h;
        b.textContent = h.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        b.addEventListener('click', function () { self.setTab(h); });
        self.tabsEl.appendChild(b);
      });
      this.setTab(this.cache.__last && handles.indexOf(this.cache.__last) > -1 ? this.cache.__last : handles[0]);
    }

    closeModal() {
      this.modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    setTab(handle) {
      this.cache.__last = handle;
      this.handleNow = handle;
      Array.prototype.forEach.call(this.tabsEl.children, function (b) {
        var active = b.dataset.handle === handle;
        b.classList.toggle('is-active', active);
        if (active && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      this.listEl.textContent = '';
      this.page = 0;
      this.done = false;
      this.loading = false;
      this.token = (this.token || 0) + 1;
      this.loadMore();
    }

    loadMore() {
      if (this.loading || this.done || this.modal.hidden) return;
      this.loading = true;
      this.loadingEl.hidden = false;
      var self = this;
      var token = this.token;
      var handle = this.handleNow;
      this.page++;
      fetch('/collections/' + handle + '/products.json?limit=50&page=' + this.page)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) {
          if (token !== self.token) return;
          var prods = data.products || [];
          if (prods.length < 50) self.done = true;
          prods.forEach(function (p) { self.addRow(p); });
          self.loading = false;
          self.loadingEl.hidden = true;
          self.filterList();
        })
        .catch(function () {
          self.loading = false;
          self.done = true;
          self.loadingEl.hidden = true;
          self.filterList();
        });
    }

    addRow(p) {
      var self = this;
      var variants = p.variants.filter(function (v) { return v.available !== false; });
      if (!variants.length) return;
      var isCurrent = String(p.id) === String(this.currentProduct && this.currentProduct.id);
      var hasVariants = variants.length > 1 || (variants[0].title && variants[0].title !== 'Default Title');

      var row = document.createElement('div');
      row.className = 'qbt__product-row' + (isCurrent ? ' is-current-product' : '');
      row.dataset.title = (p.title || '').toLowerCase();

      var thumb = document.createElement('div');
      thumb.className = 'qbt__product-thumb';
      var imgSrc = p.images && p.images[0] ? p.images[0].src : '';
      if (imgSrc) {
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = '';
        img.loading = 'lazy';
        thumb.appendChild(img);
      }
      row.appendChild(thumb);

      var info = document.createElement('div');
      info.className = 'qbt__product-info';

      var nm = document.createElement('div');
      nm.className = 'qbt__product-name';
      nm.textContent = p.title;
      info.appendChild(nm);

      var pr = document.createElement('div');
      pr.className = 'qbt__product-price';
      var prNow = document.createElement('span');
      prNow.className = 'qbt__product-price-now';
      var prCmp = document.createElement('span');
      prCmp.className = 'qbt__product-price-compare';
      pr.appendChild(prNow);
      pr.appendChild(prCmp);
      info.appendChild(pr);

      var select = null;
      if (hasVariants) {
        var vp = document.createElement('div');
        vp.className = 'qbt__product-variant-picker';

        var optNames = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; })
          .filter(function (n) { return n && n !== 'Title'; });
        if (optNames.length) {
          var lbl = document.createElement('span');
          lbl.className = 'qbt__product-variant-label';
          lbl.textContent = optNames.join(' / ');
          vp.appendChild(lbl);
        }

        select = document.createElement('select');
        select.setAttribute('aria-label', optNames.join(' / ') || 'Variant');
        variants.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.id;
          o.textContent = v.title;
          select.appendChild(o);
        });
        vp.appendChild(select);
        info.appendChild(vp);
      }
      row.appendChild(info);

      function currentV() {
        var id = select ? Number(select.value) : variants[0].id;
        return variants.filter(function (v) { return v.id === id; })[0];
      }
      function paint() {
        var v = currentV();
        var price = toCents(v.price);
        var cmp = toCents(v.compare_at_price);
        prNow.textContent = money(price);
        prCmp.textContent = cmp > price ? money(cmp) : '';
      }
      paint();
      if (select) select.addEventListener('change', paint);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qbt__product-choose';
      btn.textContent = 'Choose';
      btn.addEventListener('click', function () {
        var v = currentV();
        var vimg = (v.featured_image && v.featured_image.src) || imgSrc;
        var item = {
          productId: p.id,
          variantId: v.id,
          title: p.title + (hasVariants ? ' - ' + v.title : ''),
          image: vimg,
          price: toCents(v.price),
          compare: toCents(v.compare_at_price)
        };
        self.slots[self.activeSlot.tier][self.activeSlot.idx] = item;
        self.closeModal();
        self.renderAll();
      });
      row.appendChild(btn);

      if (isCurrent) this.listEl.insertBefore(row, this.listEl.firstChild);
      else this.listEl.appendChild(row);
    }

    filterList() {
      var q = this.searchEl.value.trim().toLowerCase();
      var shown = 0;
      Array.prototype.forEach.call(this.listEl.children, function (r) {
        var ok = !q || r.dataset.title.indexOf(q) > -1;
        r.hidden = !ok;
        if (ok) shown++;
      });
      this.noResEl.hidden = !(shown === 0 && this.done && !this.loading);
    }

    /* ---------- add to cart ---------- */
    bindNativeButtons() {
      var self = this;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.product-form__submit');
        if (!btn) return;
        var form = btn.closest('form');
        if (!form) return;
        var fid = form.getAttribute('id') || '';
        if (fid.indexOf(self.formId) !== 0) return;
        if (self.tier < 2) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        self.submitBundle(btn);
      }, true);
    }

    submitBundle(btn) {
      var self = this;
      if (btn.classList.contains('loading')) return;
      var missing = this.missingCount();
      if (missing > 0) {
        var first = 1;
        for (var i = 1; i < this.tier; i++) { if (!this.slotItem(this.tier, i)) { first = i; break; } }
        this.openModal(this.tier, first);
        return;
      }

      var map = {};
      for (var k = 0; k < this.tier; k++) {
        var it = this.slotItem(this.tier, k);
        map[it.variantId] = (map[it.variantId] || 0) + 1;
      }
      var items = Object.keys(map).map(function (id) {
        return { id: Number(id), quantity: map[id], properties: { '_bundle': 'buy-' + self.tier } };
      });

      var miniCart = document.querySelector('mini-cart');
      var body = { items: items, sections_url: window.location.pathname };
      if (miniCart) body.sections = miniCart.getSectionsToRender().map(function (s) { return s.id; }).join(',');

      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', 'true');

      fetch(theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            alert(res.description || res.message || 'Could not add to cart');
            return;
          }
          if (window.publish && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quantity-break-tiers', productVariantId: items[0].id });
          }
          if (miniCart) miniCart.renderContents(res);
          else window.location.href = theme.routes.cart_url;
        })
        .catch(function (err) { console.error(err); alert('Something went wrong adding this to your cart.'); })
        .then(function () {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
        });
    }
  }

  customElements.define('quantity-break-tiers', QuantityBreakTiers);
})();